// utils
import { setHiddenFields } from "./utils/utils"
import { protocolClassNames, objectClassNames, arrayClassNames, dateClassNames } from "../classes"

// import { jrctProtocolUISchema } from './jrctProtocolUISchema';
import { ctgProtocolUISchema } from "./ctgProtocolUISchema"

const hideFields = {
  root: [
    "study_description",
    // "eudract_number",
    "study_identification",
    "study_arms",
    "study_ipd",
    "study_outcome_measures",
    "study_reference",
    "ctis_form",
    "mscs",

    "type_of_research",
    "investigator_information",
    "non_investigator_information",
    "information_on_multicenter_clinical_trials",
    "overview_of_pharmaceuticals",
    "monetary_sponsor",
    "irb_information",
    "ema_hma_additional_information",
  ],
  contact_information: {
    root: [
      "responsible_party",
      "investigator_name",
      "investigator_official_title",
      "investigator_affiliation",
      "collaborators",
      "central_contacts",
      "central_contacts_backup",
      "overall_study_officials",
      "country_study_is_conducted",
      "investigator_contact_details",
      "investigator_center",
      "department_research_group",
      "encepp_center_organization_affiliation",
      "encepp_center_website",
      "networks_registered_encepp",
      "other_networks",
      "centers_registered_encepp",
      "other_centers",
      "institution_conducting_study",
      "institution_conducting_study_if_not_in_list",
      "additional_institutions",
      "additional_institutions_if_not_in_list",
    ],
  },
  study_oversight: {
    root: ["us_drug", "us_device", "human_subjects_protection_review", "data", "fda", "", ""],
    us_ind: {
      root: [
        "fda_center",
        "ind_ide_number",
        "ind_serial_number",
        "availability_of_expanded_access",
        "expanded_access_record",
      ],
    },
  },
  study_timeline: {
    root: [
      "record_verification_date",
      "milestone_dates",
      "expanded",
      "signed_funding_contract_date",
      // "data_collection_start_date",
      "data_analysis_start_date",
      "interim_report_date",
      "final_study_report_date",
      "funding_source",
      "plan_sponsor_audit",
      "compensation_and_medical_care_in_the_event_of_health_damage",
      "other_funding_sources",
      "more_details_sources_of_funding",
    ],
    recruitment: {
      root: ["study_stopped", "summary_results"],
    },
  },
  study_scope: {
    root: [
      "patient_registry",
      "follow_up_duration",
      "duration_type",
      "additional_patient_registry_data",
      "primary_purpose",
      "interventional_study_model",
      "model_description",
      "number_of_arms",
      "masking",
      "masking_description",
      "allocation",
      "enrollment_number",
      "enrollment_type",
      "enrollment_type_obs",
      "checkbox",
      "observational_study_model",
      "time_perspective",
      "biospecimen",
      "number_of_subjects",
      "number_of_cohorts",
      "selection",
      "scope_of_study",
      "other_scope_description",
      "design_of_study",
      // "other_design_description",
      "trial_scope",
      "ctis_trial_phase",
      "periods",
      "countries_outside_eea",
      "control",
      "placebo",
      "blinding",
      "randomization",
      "non_insurance_combined_medical_expenses",
      "countries_of_recruitment_except_japan",
      "jrct_masking",
      "summary_results",
      "data_collection_method",
      "clinical_trial_regulatory_scope",
      "other_non_interventional_study_design",
      "clinical_trial_type",
    ],
  },
  study_eligibility: {
    root: [
      "sex",
      "gender_based",
      "eligibility_criteria",
      "sampling_method",
      "population_under_study",
      "sources_of_data",
      "registered_data_sources",
      "other_registered_data_sources",
      "other_data_source",
      "principle_inclusion_criteria",
      "principle_exlusion_criteria",
      "study_population_description",
      "age_groups",
      "other_special_interest_of_population",
      "special_interest_of_population",
      "short_description_of_study_population",
    ],
  },
}

// const jrctUiSchema = jrctProtocolUISchema()
const ctgSchema = ctgProtocolUISchema()

export const secondaryAttributesUISchema = (configs) => {
  let preview = configs?.preview
  let formData = configs?.formData
  const disableValidation = configs?.disableValidation || false

  return {
    protocol: {
      "ui:order": [
        "study_details_detailed_description",
        "study_description",
        "protocol_id",
        "study_eligibilty",
        "vendor",
        "vendor_contact",
        "acquired_from",
        "transferred_to",
        "proprietary_name",
        "established_name",
        "product_manufactured",
        "compound_code",
        "generic_name",
        "brand_name",
        "primary_cro",
        "availability_expanded_access",
        "us_fda_regulated_drug_product",
        "us_fda_regulated_device_product",
        "unapproved_new_formulation_marketed_compound",
        "study_oversight",
        "secondary_ids",
        "sponsoring_division",
        "sponsoring_unit",
        "ctms_study_type",
        "ctms_study_title",
        "ctms_study_status",
        "study_termination_decision_date",
        "study_termination_reason",
        "study_termination_date",
        "study_other",
        "complex_study_program",
        "same_study_design",
        "post_study_access",
        "study_extension",
        "plsrs_posted_on_sponsor_website_off_lslv",
        "plsrs_posted_on_sponsor_website_off_pcd",
        "public_disclosure_synopsis_posted_on_sponsor_website",
        // "eu_br_rating",
        "us_br_rating",
        "post_authorization_study_type",
        "disease_area_stronghold",
        "general",
        "study_scope",
        "contact_information",
        "study_type",
        "status",
        "study_timeline",
        "milestone_dates",
        "*",
      ],
      "ui:options": {
        title: "Study Details",
        classNames: protocolClassNames,
      },
      study_details_detailed_description: {
        "ui:options": {
          title: "Title",
          charCountEnabled: true,
          maxChars: 32000,
          validations: [
            {
              regex: /^.{0,32000}$/,
              message: "Title must have no more than 32000 characters.",
            },
          ],
          label: false,
          classNames: {
            fieldContainer: "rjs-full",
          },
        },
        "ui:widget": "textarea",
      },
      study_type: {
        "ui:options": {
          title: "Study type",
          placeholder: "Select Study Type",
          label: false,
          classNames: {
            field: "rjs-col-md",
          },
        },
      },
      protocol_id: {
        "ui:options": {
          label: false,
          required: true,
          title: "Study ID",
          placeholder: "Enter Unique Protocol ID",
          disabled: true,
          charCountEnabled: true,
          maxChars: 30,
          validations: [
            {
              regex: /^.{0,30}$/,
              message: "Unique Protocol ID must have no more than 30 characters.",
            },
          ],
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      vendor: {
        "ui:options": {
          label: false,
          required: true,
          title: "Vendor",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      vendor_contact: {
        "ui:options": {
          label: false,
          required: true,
          title: "Vendor Contact",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      acquired_from: {
        "ui:options": {
          label: false,
          required: true,
          title: "Acquired from",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      transferred_to: {
        "ui:options": {
          label: false,
          required: true,
          title: "Transferred to",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      unapproved_new_formulation_marketed_compound: {
        "ui:options": {
          label: false,
          required: true,
          title: "Unapproved new formulation of a Marketed Compound",
          classNames: {
            field: "rjs-col-3xl",
          },
        },
      },
      proprietary_name: {
        "ui:options": {
          label: false,
          required: true,
          title: "Proprietary Name",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      established_name: {
        "ui:options": {
          label: false,
          required: true,
          title: "Established Name",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      product_manufactured: {
        "ui:options": {
          label: false,
          required: true,
          title: "Product Manufactured",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      compound_code: {
        "ui:options": {
          label: false,
          required: true,
          title: "Compound Code",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      generic_name: {
        "ui:options": {
          label: false,
          required: true,
          title: "Generic Name",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      brand_name: {
        "ui:options": {
          label: false,
          required: true,
          title: "Brand Name",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      primary_cro: {
        "ui:options": {
          label: false,
          required: true,
          title: "Primary CRO",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      availability_expanded_access: {
        "ui:options": {
          label: false,
          required: true,
          title: "Availability of Expanded Access",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      us_fda_regulated_drug_product: {
        "ui:options": {
          label: false,
          required: true,
          title: "U.S. FDA-regulated Drug Product",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      us_fda_regulated_device_product: {
        "ui:options": {
          label: false,
          required: true,
          title: "U.S. FDA-regulated Device Product",
          classNames: {
            field: "rjs-col-xl",
          },
        },
      },
      secondary_ids: {
        ...ctgSchema.protocol.study_identification.secondary_ids,
        "ui:options": {
          ...ctgSchema.protocol.study_identification.secondary_ids["ui:options"],
          title: "Study Identifiers",
          addButtonTitle: "Add Study Identifier",
        },
      },
      sponsoring_division: {
        "ui:options": {
          label: false,
          title: "Sponsoring Division",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      sponsoring_unit: {
        "ui:options": {
          label: false,
          title: "Sponsoring Unit",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      ctms_study_type: {
        "ui:options": {
          label: false,
          title: "CTMS Study Type",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      ctms_study_title: {
        "ui:options": {
          label: false,
          title: "CTMS Study Title",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      ctms_study_status: {
        "ui:options": {
          label: false,
          title: "CTMS Study Status",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      study_termination_decision_date: {
        // "ui:options": {
        //   title: "Study Termination Decision Date",
        //   label: false,
        //   classNames: {
        //     field: "rjs-col-date",
        //   },
        // },
        // "ui:widget": "date",

        "ui:options": {
          title: "Study Termination Decision Date",
          classNames: objectClassNames.pactdate,
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      study_termination_reason: {
        "ui:options": {
          label: false,
          title: "Study Termination Reason",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      study_termination_date: {
        "ui:options": {
          title: "Study Termination Date",
          classNames: objectClassNames.pactdate,
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      study_other: {
        "ui:options": {
          label: false,
          title: "Study Other",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      complex_study_program: {
        "ui:options": {
          label: false,
          title: "Complex Study Program",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      same_study_design: {
        "ui:options": {
          label: false,
          title: "Same Study Design",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      post_study_access: {
        "ui:options": {
          label: false,
          title: "Post Study Access",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      study_extension: {
        "ui:options": {
          label: false,
          title: "Study Extension",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      plsrs_posted_on_sponsor_website_off_lslv: {
        // "ui:options": {
        //   label: false,
        //   title: "PLSRS Posted on Sponsor Website off LSLV",
        //   classNames: {
        //     field: "rjs-col-date",
        //   },
        // },
        // "ui:widget": "date",
        "ui:options": {
          title: "PLSRS Posted on Sponsor Website off LSLV",
          classNames: objectClassNames.pactdate,
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      plsrs_posted_on_sponsor_website_off_pcd: {
        // "ui:options": {
        //   label: false,
        //   title: "PLSRS Posted on Sponsor Website off PCD",
        //   classNames: {
        //     field: "rjs-col-date",
        //   },
        // },
        // "ui:widget": "date",
        "ui:options": {
          title: "PLSRS Posted on Sponsor Website off PCD",
          classNames: objectClassNames.pactdate,
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      public_disclosure_synopsis_posted_on_sponsor_website: {
        // "ui:options": {
        //   label: false,
        //   title: "Public Disclosure Synopsis Posted on Sponsor Website",
        //   classNames: {
        //     field: "rjs-col-date",
        //   },
        // },
        // "ui:widget": "date",
        "ui:options": {
          title: "Public Disclosure Synopsis Posted on Sponsor Website",
          classNames: objectClassNames.pactdate,
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      // eu_br_rating: {
      //   "ui:options": {
      //     label: false,
      //     title: "EU BR Rating",
      //     classNames: {
      //       field: "rjs-col-lg",
      //     },
      //   },
      // },
      // us_br_rating: {
      //   "ui:options": {
      //     label: false,
      //     title: "US BR Rating",
      //     classNames: {
      //       field: "rjs-col-lg",
      //     },
      //   },
      // },
      post_authorization_study_type: {
        "ui:options": {
          label: false,
          title: "Post Authorization Study Type",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      disease_area_stronghold: {
        "ui:options": {
          label: false,
          title: "Disease Area Stronghold",
          classNames: {
            field: "rjs-col-lg",
          },
        },
      },
      general: {
        "ui:options": {
          title: "General",
          classNames: {
            ...objectClassNames.primary,
            field: "mb-0",
          },
        },
        countries: {
          "ui:options": {
            title: "Countries",
            type: "string",
            placeholder: "--Select--",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        indication: {
          "ui:options": {
            label: false,
            title: "Indication",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        remarks: {
          "ui:options": {
            label: false,
            title: "Remarks",
            classNames: {
              fieldContainer: "rjs-full",
            },
          },
          "ui:widget": "textarea",
        },
        eudract_number: {
          "ui:options": {
            label: false,
            title: "EudraCT Number",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        intervention_type: {
          "ui:options": {
            title: "Intervention Type",
            placeholder: "--Select--",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        product_id: {
          "ui:options": {
            label: false,
            title: "Product ID",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        product_name: {
          "ui:options": {
            label: false,
            title: "Product Name",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        program_id: {
          "ui:options": {
            label: false,
            title: "Program ID",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        program_name: {
          "ui:options": {
            label: false,
            title: "Program Name",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        therapeutic: {
          "ui:options": {
            label: false,
            title: "Therapeutic Area",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        countries_manufactured: {
          "ui:options": {
            title: "Country DP Manufactured",
            placeholder: "--Select--",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
          "ui:widget": "MultiSelect",
        },
        age_group: {
          "ui:options": {
            title: "Age Group",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
      },
      status: {
        "ui:options": {
          title: "Status",
          classNames: objectClassNames.pactdate,
        },
        study_status: {
          "ui:options": {
            label: false,
            title: "Study Status",
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
        record_status: {
          "ui:options": {
            title: "Record Status",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
        },
      },
      milestone_dates: {
        "ui:options": {
          title: "Milestone Dates",
          classNames: objectClassNames.primary,
        },
        conception_date: {
          // "ui:options": {
          //   title: "Conception Date",
          //   label: false,
          //   classNames: {
          //     ...objectClassNames.pactdate,
          //     fieldContainer: "rjs-full",
          //     field: "rjs-col-md",
          //   },
          // },
          // "ui:widget": "date",
          "ui:options": {
            title: "Conception Date",
            classNames: objectClassNames.pactdate,
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        pra: {
          "ui:options": {
            title: "Protocol Approval Date",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        fpi: {
          "ui:options": {
            title: "Study Start Date",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        lpo: {
          "ui:options": {
            title: "Study Completion Date - LPO/LPLV/SCD",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        pcd: {
          "ui:options": {
            title: "Primary Completion Date",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        csr: {
          "ui:options": {
            title: "Clinical Study Report Completed",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        fsa: {
          "ui:options": {
            title: "First Site Activation Date",
            classNames: objectClassNames.pactdate,
          },
          baseline: {
            "ui:options": {
              title: "Baseline",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        recruitment_end_date: {
          "ui:options": {
            title: "Recruitment End Date/LPFV",
            classNames: objectClassNames.pactdate,
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
        first_patient_enrolled_date: {
          "ui:options": {
            title: "First Patient Enrolled",
            classNames: objectClassNames.pactdate,
          },
          forecast: {
            "ui:options": {
              title: "Forecast",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
          actual: {
            "ui:options": {
              title: "Actual",
              label: false,
              classNames: {
                field: "rjs-col-date",
              },
            },
            "ui:widget": "date",
          },
        },
      },
      secondary_attributes: {
        "ui:options": {
          title: "Secondary Attributes",
          classNames: objectClassNames.primary,
        },
        internal: {
          "ui:options": {
            title: "Internal",
            classNames: objectClassNames.secondary,
          },
          first_product_indication_approval_date_in_any_country: {
            "ui:options": {
              title: "First Product and Indication Approval Date in Any Country",
              classNames: objectClassNames.pactdateFull,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          product_indication_first_approval_date: {
            "ui:options": {
              title: "Product and Indication First Approval Date",
              classNames: objectClassNames.pactdateFull,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          fcsr_live: {
            "ui:options": {
              title: "CSR Completion Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          fpi_live: {
            "ui:options": {
              title: "First Patient In Date (FPI) Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          fsa_live: {
            "ui:options": {
              title: "First Site Active date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          lpi_live: {
            "ui:options": {
              title: "Last Patient In Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          lpo_live: {
            "ui:options": {
              title: "Last Patient Out Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          lpop_live: {
            "ui:options": {
              title: "Primary Completion Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          pca_live: {
            "ui:options": {
              title: "Protocol Concept Approval Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          pra_live: {
            "ui:options": {
              title: "Protocol Approval Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          tlgs_live: {
            "ui:options": {
              title: "TLGs Availability Date Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          first_patient_consented_live: {
            "ui:options": {
              title: "First Patient Consented - Live Forecast",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                label: false,
                removeLabel: true,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          first_patient_consented: {
            "ui:options": {
              title: "First Patient Consented",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          lpi: {
            "ui:options": {
              title: "Last Patient In Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          pca: {
            "ui:options": {
              title: "Protocol Concept Approved",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          tlgs: {
            "ui:options": {
              title: "TLGs Availability Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          gov_approval: {
            "ui:options": {
              title: "Governance Approval",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Planned",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          alternate_id: {
            "ui:options": {
              title: "Alternate ID",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          affiliate_val: {
            "ui:options": {
              title: "Affiliate",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          primary_site_location: {
            "ui:options": {
              title: "Primary Site Location",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-2xl",
              },
            },
          },
          redacted_documents: {
            "ui:options": {
              title: "Status of Redacted Documents For Submission to CTG",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          result_preparation: {
            "ui:options": {
              label: false,
              title: "Status of Received TFLs for Study Results Preparation",
              classNames: {
                fieldContainer: "rjs-col-2xl",
              },
            },
          },
          lsfd: {
            "ui:options": {
              title: "Last Subject First Dose Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          long_term_follow_up_lplv: {
            "ui:options": {
              title: "Long Term Follow Up LPLV",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          in_scope_for_data_sharing: {
            "ui:options": {
              title: "In Scope for Data Sharing",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
            "ui:widget": "radio",
          },
          journal_publication: {
            "ui:options": {
              label: false,
              title: "Journal Publication",
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
          },
          publication_plan: {
            "ui:options": {
              label: false,
              title: "Publication Plan",
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": "textarea",
          },
          document_redaction_required: {
            "ui:options": {
              title: "Document Redaction Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
            "ui:widget": "radio",
          },
          redaction_required_for_publication: {
            "ui:options": {
              title: "Redaction Required for Publication",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
            "ui:widget": "radio",
          },
          product_approval_date_on_before_lpo: {
            "ui:options": {
              title: "Product Approval Date is on or before LPO",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          product_indication_approved_in_any_country: {
            "ui:options": {
              title: "Product and Indication is Approved in Any Country",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          product_discontinued: {
            "ui:options": {
              title: "Product Discontinued",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          product_discontinued_date: {
            "ui:options": {
              title: "Product Discontinued Date",
              classNames: objectClassNames.pactdateFull,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          study_db_lock_date: {
            "ui:options": {
              title: "Study Database Lock Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Planned",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          health_literacy_completion_date: {
            // "ui:options": {
            //   title: "Health Literacy Completion Date",
            //   label: false,
            //   classNames: {
            //     field: "rjs-col-date",
            //   },
            // },
            // "ui:widget": "date",

            "ui:options": {
              title: "Health Literacy Completion Date",
              classNames: objectClassNames.pactdate,
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          transfer_date: {
            // "ui:options": {
            //   title: "Transfer Date",
            //   label: false,
            //   classNames: {
            //     field: "rjs-col-date",
            //   },
            // },
            // "ui:widget": "date",

            "ui:options": {
              title: "Transfer Date",
              classNames: objectClassNames.pactdate,
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          acquisition_date: {
            // "ui:options": {
            //   title: "Acquisition Date",
            //   label: false,
            //   classNames: {
            //     field: "rjs-col-date",
            //   },
            // },
            // "ui:widget": "date",
            "ui:options": {
              title: "Acquisition Date",
              classNames: objectClassNames.pactdate,
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          health_authority_initial_submission_date: {
            "ui:options": {
              title: "Health Authority Initial Submission Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Planned",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          health_authority_initial_approval_date: {
            "ui:options": {
              title: "Health Authority Initial Approval Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Planned",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          first_subject_screened_date: {
            "ui:options": {
              title: "First Subject Screened Date",
              classNames: objectClassNames.pactdate,
            },
            forecast: {
              "ui:options": {
                title: "Planned",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },

          post_authorization_safety_study: {
            "ui:options": {
              title: "Post Authorization Safety Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          post_authorization_efficacy_study: {
            "ui:options": {
              title: "Post Authorization Efficacy Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
        },
        usa: {
          "ui:options": {
            title: "USA",
            classNames: objectClassNames.secondary,
          },
          device_feasibility_study: {
            "ui:options": {
              title: "Device Feasibility Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          is_product_fda_approved: {
            "ui:options": {
              title: "Product and Indication FDA Approved",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          product_indication_approved_by_fda_and_ema_on_or_before_lpo: {
            "ui:options": {
              title: "Product and Indication is approved by FDA and EMA on or before LPO date",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-2xl",
              },
            },
            "ui:widget": "radio",
          },
          // fda_product_approval_date: {
          //   "ui:options": {
          //     title: "Product and Indication FDA Approval Date",
          //     classNames: objectClassNames.pactdate
          //   },
          //   baseline: {
          //     "ui:options": {
          //       removeLabel: true,
          //       label: false,
          //     },
          //     "ui:widget": "date"
          //   },
          // },
          ctg_delay_certification_submitted_date: {
            "ui:options": {
              title: "CTG Delayed Certification Submitted Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                removeLabel: true,
              },
              "ui:widget": "date",
            },
          },
          // us_ind_ide: {
          //   "ui:options": {
          //     title: "US FDA IND/IDE",
          //     label: false,
          //     styles: {
          //       field: {
          //         width: "50%",
          //         marginTop: 12
          //       },
          //       widgetContainer: widgetContainer.lg
          //     }
          //   },
          //   "ui:widget": "radio",
          // },
          us_imp: {
            "ui:options": {
              title: "US IMP",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          // us_ide: {
          //   "ui:options": {
          //     title: "US IDE",
          //     label: false,
          //     styles: {
          //       field: {
          //         width: "50%",
          //         marginTop: 12
          //       },
          //       widgetContainer: widgetContainer.lg
          //     }
          //   },
          //   "ui:widget": "radio",
          // },
          section_801: {
            "ui:options": {
              title: "Section 801",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          is_ctg_delay_certification_submitted: {
            "ui:options": {
              title: "CTG Delayed Certification Filed",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          manufactured_in_us: {
            "ui:options": {
              title: "Manufactured in or Exported from the US",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          maintenance_amendment_required: {
            "ui:options": {
              title: "Maintenance/Amendment Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          ctg_maintenance_required: {
            "ui:options": {
              title: "CTG Maintenance Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          protocol_amendment_required: {
            "ui:options": {
              title: "Protocol Amendment Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* product_discontinuation_date_on_before_lpo: {
            "ui:options": {
              title: "Product Discontinuation Date is on or before LPO",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          FDA_approval_of_drug_for_the_indication_received_after_1_year_of_PCD: {
            "ui:options": {
              title: "FDA Approval Of Drug For The Indication Received After 1 Year Of PCD",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* LPO_1_year_after_the_date_of_filing_of_delayed_results: {
            "ui:options": {
              title: "LPO is 1 Year After The Date Of Filing Of Delayed Results?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
  
          }, */
          product_fda_any: {
            "ui:options": {
              title: "Product is FDA Approved for any use",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* is_drug_fda_approved_any_use_before_PCD: {
            "ui:options": {
              title: "Drug is FDA Approved For Any Use Before PCD",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* is_drug_fda_approved_any_use_before_LPO: {
            "ui:options": {
              title: "Drug is FDA approved for any use before LPO",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* is_fda_approval_of_drug_for_the_indication_received_after_1_year_of_LPO: {
            "ui:options": {
              title: "FDA Approval Of Drug For The Indication is Received After 1 Year Of LPO",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* product_and_indication_approved_by_FDA_before_PCD: {
            "ui:options": {
              title: "Product and Indication is approved by FDA before PCD",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* product_for_the_indication_studied_approved_by_FDA_before_LPO: {
            "ui:options": {
              title: "Product for the Indication studied is approved by FDA before LPO",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* SCD_1_year: {
            "ui:options": {
              title: "Is SCD 1 year after the date of delayed results filing?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* SCD_2_year: {
            "ui:options": {
              title: "Is SCD 2 years after the date of delayed results filing?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          },
          is_pcd: {
            "ui:options": {
              title: "Is PCD=SCD?",
              label: false,
              disabled: true,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          },*/
          type_results: {
            "ui:options": {
              title: "Type of Results",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          fda_market_approval: {
            "ui:options": {
              title: "FDA Market Approval",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          manufacturer: {
            "ui:options": {
              title: "Manufacturer",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          fda_product_approval_date_any_use: {
            "ui:options": {
              title: "FDA Product Approval Date for any use",
              classNames: {
                objectTitle: "rjs-h3",
                fieldContainer: "rjs-col-lg",
              },
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          ctg_interim_results_required: {
            "ui:options": {
              title: "CTG Interim Results Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          fda_product_approval_date: {
            "ui:options": {
              title: "Product and Indication FDA Approval Date",
              classNames: objectClassNames.tertiary,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          product_indication_latest_approval_date_fda_ema: {
            "ui:options": {
              title: "Product and Indication Latest Approval Date (FDA & EMA)",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          delayed_certification_filed_date: {
            "ui:options": {
              title: "Delayed Certification Filed Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          /*    expanded_access_availability_date: {
              "ui:options": {
                title: "Expanded Access Availability Date",
                styles: {
                  field: {
                    width: "100%",
                    marginBottom: 16
                  },
                  objectTitle: {
                    fontWeight: "bold"
                  },
                  objectInnerContainer: {
                    ...containerFlexStart,
                    // width: noMarginWidgetContainer.md.width * 4
                  },
                }
              },
              baseline: {
                "ui:options": {
                  title: "Baseline",
                  label: false,
                  styles: {
                  field: widgetContainerMarginRight.md,
                  widgetContainer: widgetContainerMarginRight.md
                  }
                },
                "ui:widget": "date"
              },
              forecast: {
                "ui:options": {
                  title: "Forecast",
                  label: false,
                  styles: {
                  field: widgetContainerMarginRight.md,
                  widgetContainer: widgetContainerMarginRight.md
                  }
                },
                "ui:widget": "date"
              },
              actual: {
                "ui:options": {
                  title: "Actual",
                  label: false,
                  styles: {
                  field: widgetContainerMarginRight.md,
                  widgetContainer: widgetContainerMarginRight.md
                  }
                },
                "ui:widget": "date"
              },
            }, */
        },
        europe: {
          "ui:options": {
            title: "Europe",
            classNames: objectClassNames.secondary,
          },
          applicable_eu_regulation: {
            "ui:options": {
              title: "Applicable EU Regulation",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-2xl",
              },
            },
            "ui:widget": "radio",
          },
          eu_marketing_authorization: {
            "ui:options": {
              title: "EU Marketing Authorization",
              label: false,
            },
            "ui:widget": "radio",
          },
          ema_cta_date: {
            "ui:options": {
              title: "EMA CTA Approval Date",
              classNames: objectClassNames.tertiary,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          ema_cta: {
            "ui:options": {
              title: "EMA CTA Approved",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          pass_category: {
            "ui:options": {
              label: false,
              title: "PASS Category",
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          pediatric_study: {
            "ui:options": {
              title: "Pediatric Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          eu_pip: {
            "ui:options": {
              title: "EU PIP",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          date_of_latest_approval: {
            "ui:options": {
              title: "Date Of Latest Approval",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          part_of_an_agreed_pip: {
            "ui:options": {
              title: "Part Of An Agreed PIP",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* marketing_holder: {
            "ui:options": {
              title: "Is the Sponsor of the Study the Same as the EU Marketing Authorization Holder?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          date_of_cta: {
            "ui:options": {
              title: "EU CTA Submitted Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          date_of_results: {
            "ui:options": {
              title: "EU Results Submitted Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          eu_subsequent_marketing_authorization_application_date: {
            "ui:options": {
              title: "EU Subsequent Marketing Authorization Application Date",
              classNames: objectClassNames.tertiary,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          marketing_authorization_holder_for_the_product_under_investigation: {
            "ui:options": {
              title: "Marketing Authorization Holder For The Product Under Investigation",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          // pass: {
          //   "ui:options": {
          //     title: "Pass Status",
          //     label: false,
          //     classNames: {
          //       fieldContainer: "rjs-col-lg",
          //     },
          //   },
          //   "ui:widget": "radio",
          // },
          eudract_interim_results_required: {
            "ui:options": {
              title: "EU CTR Interim Results Required",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          trial_ongoing_in_eu_eea_on_after_jan312025: {
            "ui:options": {
              title: "Will trial be ongoing in EU/EEA on or after 31 Jan 2025",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          sponsor_opted_for_submission_per_eu_directive: {
            "ui:options": {
              title: "Has Sponsor opted for submission per EU Directive?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          cta_submission_per_eu_directive_complete: {
            "ui:options": {
              title: "Is CTA submission as per EU Directive complete?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          intermediate_result_analysis_specified_in_protocol: {
            "ui:options": {
              title: "Has intermediate result analysis been specifed in Protocol?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          date_of_initial_application_cta_submitted_in_eu_eea: {
            "ui:options": {
              title: "Date of Initial Application (CTA) submitted/to be submitted in EU/EEA",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          lpo_interim_analysis: {
            "ui:options": {
              title: "LPO for Interim Analysis",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          lpo_eu_eea: {
            "ui:options": {
              title: "Last Patient Out Date in EU/EEA",
              classNames: {
                ...objectClassNames.pactdate,
                fieldContainer: "rjs-full",
              },
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          intermediate_data_analysis_date: {
            "ui:options": {
              title: "Intermediate Data Analysis Date",
              classNames: objectClassNames.pactdate,
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          eu_article_41: {
            "ui:options": {
              label: false,
              title: "EU Article 41",
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          eu_article_45: {
            "ui:options": {
              label: false,
              title: "EU Article 45",
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
          eu_article_46: {
            "ui:options": {
              label: false,
              title: "EU Article 46",
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
          },
        },
        germany: {
          "ui:options": {
            title: "Germany",
            classNames: objectClassNames.secondary,
          },
          confirmatory_study: {
            "ui:options": {
              title: "Confirmatory Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          germany_cta_date: {
            "ui:options": {
              title: "Germany CTA Approval Date",
              classNames: objectClassNames.tertiary,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          germany_cta: {
            "ui:options": {
              title: "Germany CTA Approved",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
          mma_smaa_approval_date: {
            "ui:options": {
              title: "New Product Authorization/Variation/Rejection Date",
              classNames: objectClassNames.tertiary,
            },
            baseline: {
              "ui:options": {
                title: "Baseline",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            forecast: {
              "ui:options": {
                title: "Forecast",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
            actual: {
              "ui:options": {
                title: "Actual",
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },

              "ui:widget": "date",
            },
          },
          product_authorized_in_eu_germany: {
            "ui:options": {
              title: "Product Authorized In EU or Germany",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
          /* product_authorized_in_EU_or_Germany_before_LPO: {
            "ui:options": {
              title: "Product Authorized In EU or Germany Before LPO",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-;g"
                  }
            },
            "ui:widget": "radio",
          }, */
          product_authorized_in_eu_germany_date: {
            "ui:options": {
              title: "Product Authorization Date In EU or Germany (Earliest)",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          /* product_authorized_in_eu_germany_before_jan272022: {
            "ui:options": {
              title: "Product authorized in EU/Germany before 27 Jan,2022 ",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-;g"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* product_authorized_eu_germany_before_july272021: {
            "ui:options": {
              title: "Product authorized in EU/Germany before 27 July 2021",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-;g"
                  }
            },
            "ui:widget": "radio",
          }, */
          mma_smaa_submitted_to_germany: {
            "ui:options": {
              title: "Is trial included in a new product authorization/variation/rejection",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
        },
        spain: {
          "ui:options": {
            title: "Spain",
            classNames: objectClassNames.secondary,
          },
          aemps_authorization: {
            "ui:options": {
              title: "AEMPS Authorization/Approved by AEMPS",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
          post_authorization_study: {
            "ui:options": {
              title: "Post-Authorization Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
          rec_authorization: {
            "ui:options": {
              title: "REC Authorization",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-;g",
              },
            },
            "ui:widget": "radio",
          },
          rec_authorization_date: {
            "ui:options": {
              title: "REC Authorization Date",
              classNames: objectClassNames.pactdate,
            },
            actual: {
              "ui:options": {
                title: "Actual",
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          registered_on_reec: {
            "ui:options": {
              title: "Registered on REeC",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          with_prospective_follow_up_drugs: {
            "ui:options": {
              title: "Prospective Follow-up Drugs Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          results_published_in_any_scientific_journal_or_other_media: {
            "ui:options": {
              title: "Results Already Published in Any Scientific Journal or Other Media",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          involves_medicinal_product: {
            "ui:options": {
              title: "Study involves a medicinal product?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          date_of_publication: {
            "ui:options": {
              title: "Date of Publication of Results",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
        },
        netherlands: {
          "ui:options": {
            title: "Netherlands",
            classNames: objectClassNames.secondary,
          },
          involves_dutch_people: {
            "ui:options": {
              title: "Involves Dutch Participants or Researchers",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* study_protocol_submitted_to_ccmo_on_after_mar152002: {
            "ui:options": {
              title: "Is study protocol submitted to CCMO for assessment on or after March 15,2002?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
        },
        mexico: {
          "ui:options": {
            title: "Mexico",
            classNames: objectClassNames.secondary,
          },
          cofepris_approval: {
            "ui:options": {
              title: "COFEPRIS Approval",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          cofepris_approval_date: {
            "ui:options": {
              title: "COFEPRIS Approval Date",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
        },
        south_korea: {
          "ui:options": {
            title: "South Korea",
            classNames: objectClassNames.secondary,
          },
          study_funded_by_korean_ministry_of_health_welfare: {
            "ui:options": {
              title: "Is study funded by Korean Ministry of Health and Welfare?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          study_registered_on_cris: {
            "ui:options": {
              title:
                "Is study registered on CRIS (Clinical Research Information Service - primary registry of South Korea)?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* study_approved_by_mfds_before_2019: {
            "ui:options": {
              title: "Is the study approved by Korean Ministry of Food and Drug(MFDS) before 2019?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
        },
        japan: {
          "ui:options": {
            title: "Japan",
            classNames: objectClassNames.secondary,
          },
          bioequivalence_study: {
            "ui:options": {
              title: "Bioequivalence Study",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          product_approved_in_any_country: {
            "ui:options": {
              title: "Product is Approved In Any Country",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* product_approved_in_any_country_before_lpo: {
            "ui:options": {
              title: "Product is Approved In Any Country Before LPO?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          /* submission: {
            "ui:options": {
              title: "Submission of clinical trial notification before September 1, 2020",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          date_of_approval: {
            "ui:options": {
              title: "Date of Approval in Any Country",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          trial_notification_submission_date: {
            "ui:options": {
              title: "Date of submission of clinical trial notification",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
        },
        united_kingdom: {
          "ui:options": {
            title: "United Kingdom",
            classNames: objectClassNames.secondary,
          },
          /* study_approved: {
            "ui:options": {
              title: "Study approved by UKs research ethics committee before 01 January 2021",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          clinical_trial: {
            "ui:options": {
              title: "Clinical trial registration available publicly on a public register",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* ctimp_submitted_on_after_jan012022: {
            "ui:options": {
              title: "CTIMP submitted on or after 01 January 2022?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          is_research_study: {
            "ui:options": {
              title: "Is this a research study ?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
          /* final_report_submitted_before_sep152021: {
            "ui:options": {
              title: "Has the final report been submitted before September 15, 2021?",
              label: false,
                  classNames: {
                    fieldContainer: "rjs-col-lg"
                  }
            },
            "ui:widget": "radio",
          }, */
          final_report_submission_date: {
            "ui:options": {
              title: "Date of final report submission",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          study_approval_uk_research_ethics_committee_date: {
            "ui:options": {
              title: "Date of study approval by UK’s Research Ethics Committee",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
          ctimp_submission_date: {
            "ui:options": {
              title: "Date of CTIMP submission",
              classNames: objectClassNames.pactdate,
            },
            baseline: {
              "ui:options": {
                removeLabel: true,
                label: false,
                classNames: {
                  field: "rjs-col-date",
                },
              },
              "ui:widget": "date",
            },
          },
        },
        australia_and_newzealand: {
          "ui:options": {
            title: "Australia and New Zealand",
            classNames: objectClassNames.secondary,
          },
          study_registered_on_anzctr: {
            "ui:options": {
              title: "Is study registered on ANZCTR?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
        },
        south_africa: {
          "ui:options": {
            title: "South Africa",
            classNames: objectClassNames.secondary,
          },
          study_approved_by_south_african_research_ethics_committee: {
            "ui:options": {
              title: "Is the study approved by a South African research ethics committee?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
            "ui:widget": "radio",
          },
          is_the_study_registered_on_pactr: {
            "ui:options": {
              title: "Is the study registered on PACTR?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            },
            "ui:widget": "radio",
          },
        },
        switzerland: {
          "ui:options": {
            title: "Switzerland",
            classNames: objectClassNames.secondary,
          },
          study_received_approval_from_swiss_ethics_committee: {
            "ui:options": {
              title: "Has the study received approval from Swiss ethics committee?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
        },
        china: {
          "ui:options": {
            title: "China",
            classNames: objectClassNames.secondary,
          },
          new_drug_application_submitted_to_chinese_authority: {
            "ui:options": {
              title: "Is the new drug application submitted to Chinese authority?",
              label: false,
              classNames: {
                fieldContainer: "rjs-col-lg",
              },
            },
            "ui:widget": "radio",
          },
        },
      },
      protocol_amendments: {
        "ui:options": {
          title: "Protocol Amendments",
          classNames: objectClassNames.primary,
          tooltip:
            "If the auto-creation of Protocol Amendment activities is enabled, Prime will automatically create an activity with the earliest future due date, calculated as Amendment Date + 30 days. If the due date needs to be updated, you can manually update it on the Activity Overview page. If no amendments with a future due date are found, Prime will not create an activity automatically. If required, please create it manually from the Activities tab.",
        },
        protocol_amendment: {
          "ui:options": {
            addButtonTitle: "Add Protocol Amendment",
            arrayItemTitle: "Protocol Amendment",
            label: false,
            addable: true,
            removable: true,
            orderable: true,
            showIndex: true,
            classNames: arrayClassNames.primary,
          },
          items: {
            number: {
              "ui:options": {
                title: "Number",
                label: false,
                classNames: {
                  fieldContainer: "rjs-col-lg",
                },
              },
            },
            type: {
              "ui:options": {
                title: "Type",
                label: false,
                classNames: {
                  fieldContainer: "rjs-col-lg",
                },
              },
            },
            date: {
              "ui:options": {
                title: "Date",
                label: false,
                classNames: {
                  fieldContainer: "rjs-col-lg",
                },
              },
              "ui:widget": "date",
            },
            reason: {
              "ui:options": {
                title: "Reason",
                label: false,
                classNames: {
                  fieldContainer: "rjs-full",
                },
              },
              "ui:widget": "textarea",
            },
            comments: {
              "ui:options": {
                title: "Comments",
                label: false,
                classNames: {
                  fieldContainer: "rjs-full",
                },
              },
              "ui:widget": "textarea",
            },
          },
        },
      },
      contact_information: {
        "ui:order": [
          "responsible_party",
          "sponsor",
          "investigator_name",
          "investigator_official_title",
          "investigator_affiliation",
          "*",
        ],
        "ui:options": {
          classNames: objectClassNames.pactdate,
        },
        sponsor: {
          "ui:options": {
            title: "Sponsor",
            placeholder: "Select Sponsor",
            required: true,
            label: false,
            classNames: {
              fieldContainer: "rjs-col-xl",
            },
          },
          "ui:widget": "Lookahead",
        },
        ...setHiddenFields(hideFields.contact_information.root),
      },
      study_oversight: {
        "ui:options": {
          classNames: {
            fieldContainer: "rjs-full",
          },
        },
        us_ind: {
          "ui:options": {
            classNames: objectClassNames.pactdate,
          },
          us_fda_ind_ide: {
            "ui:options": {
              title: "U.S. FDA IND/IDE",
              required: true,
              label: false,
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": "radio",
          },
          ...setHiddenFields(hideFields.study_oversight.us_ind.root),
        },
        ...setHiddenFields(hideFields.study_oversight.root),
      },
      study_timeline: {
        "ui:options": {
          classNames: {
            fieldContainer: "rjs-full mb-24",
          },
        },
        recruitment: {
          "ui:options": {
            label: false,
            classNames: {
              fieldContainer: "rjs-full",
            },
          },
          recruitment_status: ctgSchema.protocol.study_timeline.recruitment.recruitment_status,
          ...setHiddenFields(hideFields.study_timeline.recruitment.root),
        },
        ...setHiddenFields(hideFields.study_timeline.root),
      },
      study_scope: {
        "ui:order": ["study_phase", "primary_purpose", "*"],
        "ui:options": {
          classNames: objectClassNames.pactdate,
        },
        study_phase: ctgSchema.protocol.study_scope.study_phase,
        ...setHiddenFields(hideFields.study_scope.root),
      },
      study_eligibilty: {
        "ui:order": ["accept_healthy_volunteers", "is_clinical_study", "age_limits", "*"],
        "ui:options": {
          classNames: {
            ...objectClassNames.primary,
            field: "mb-0",
          },
        },
        age_limits: ctgSchema.protocol.study_eligibilty.age_limits,
        accept_healthy_volunteers: ctgSchema.protocol.study_eligibilty.accept_healthy_volunteers,
        is_clinical_study: {
          "ui:options": {
            title: "Is this a clinical study?",
            label: false,
            classNames: {
              fieldContainer: "rjs-col-lg",
            },
          },
          "ui:widget": "radio",
        },
        ...setHiddenFields(hideFields.study_eligibility.root),
      },
      ...setHiddenFields(hideFields.root),
    },
  }
}
